// extracted by mini-css-extract-plugin
module.exports = {"Text":"Text--1Bfhg","Bars":"Bars--2WZSI","Wrapper":"Wrapper--2Gbkd","MetricWrapper":"MetricWrapper--OPfe0","KpiCell":"KpiCell--1AtH7"};